// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__DPwI5","Open":"SideDrawer_Open__q5-90","Close":"SideDrawer_Close__2zy7q","Logo":"SideDrawer_Logo__++MwY"};